import { FC } from 'react'

import { ValidationError } from '@sequencehq/utils'
import { Option, Flex } from '@sequencehq/core-components'
import { ConfigFormTemplate } from '../ConfigFormTemplate'
import { ApproverMultiSelectControl } from './ApproverMultiSelectControl'
import { ApproversList } from './ApproversList'

/**
 * The "Approvers" section shared by the reminder and review config forms: an
 * always-visible subheading, the selected approvers and the add-approver
 * control, all aligned to the right-hand side of the form.
 */
export const ApproversField: FC<{
  approvers: Array<{ id: string; email: string }>
  onRemoveApprover: (userId: string) => void
  userOptions: Option[]
  approverUserIds: string[]
  isUsersPending: boolean
  multiSelectKey: number
  onApproversChange: (userIds: string[]) => void
  validationErrors?: Pick<ValidationError, 'message'>[]
  initiallyOpen?: boolean
  testIdPrefix: string
}> = ({
  approvers,
  onRemoveApprover,
  userOptions,
  approverUserIds,
  isUsersPending,
  multiSelectKey,
  onApproversChange,
  validationErrors,
  initiallyOpen,
  testIdPrefix
}) => {
  const hasApprovers = approvers.length > 0

  return (
    <ConfigFormTemplate.Row label="Approvers" gap="8px">
      {hasApprovers && (
        <ApproversList
          data-testid={`${testIdPrefix}.approversList`}
          approvers={approvers}
          onDelete={onRemoveApprover}
          alignItems="flex-end"
        />
      )}

      <Flex width="100%" justifyContent="flex-end">
        <ApproverMultiSelectControl
          data-testid={`${testIdPrefix}.addApprover`}
          key={multiSelectKey}
          options={userOptions}
          initialValues={approverUserIds}
          isDisabled={isUsersPending}
          onChange={onApproversChange}
          initiallyOpen={initiallyOpen}
          validationErrors={validationErrors}
        />
      </Flex>
    </ConfigFormTemplate.Row>
  )
}
